import React, { FunctionComponent, useEffect, useState } from "react";
import { LVStrings } from "@my-dld/assets/strings";
import PropertyPhotos from "./PropertyPhotos";
import { PropertyDocuments } from "./PropertyDocuments";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil, StringUtil } from "@eres/core";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { navigate } from "@my-dld/utils/StoreUtils";
import { ManagementCompany } from "./ManagementCompany";
import { Gated } from "@10x/feature-gate";
import { ServiceCard } from "../ServiceContainer";
import PropertyServices from "./PropertyServices";
import { Details } from "./Details";
import { UnitSystem } from "@my-dld/utils/UnitUtils";

enum TabIDs {
	PROPERTY_SERVICES = "property_services",
	PROPERTY_PHOTOS = "property_photos",
	PROPERTY_DOCUMENTS = "property_documents",
	MANAGEMENT_COMPANY = "management_company",
	PROPERTY_DETAILS = "property_details",
}

interface ITab<P> {
	id: string;
	name: LocaleValue;
	screen: FunctionComponent<P>;
}

const PropertyDetailsTabs: ITab<any>[] = [
	{
		id: TabIDs.PROPERTY_DETAILS,
		name: LVStrings.property_details,
		screen: Details,
	},
	{
		id: TabIDs.PROPERTY_SERVICES,
		name: LVStrings.property_services,
		screen: PropertyServices,
	},
	{
		id: TabIDs.PROPERTY_PHOTOS,
		name: LVStrings.property_photos,
		screen: PropertyPhotos,
	},
	{
		id: TabIDs.PROPERTY_DOCUMENTS,
		name: LVStrings.property_documents,
		screen: PropertyDocuments,
	},
	{
		id: TabIDs.MANAGEMENT_COMPANY,
		name: LVStrings.management_company_text,
		screen: PropertyPhotos,
	},
];

export function DetailsTabs( props: { data: AssetCard, services: ServiceCard[], hideServices: boolean, unit?: UnitSystem, onBCSReValuate?: () => void } ) {
	const { data, services, hideServices, unit , onBCSReValuate } = props;
	const [ tabs, setTabs ] = useState<ITab<any>[]>( PropertyDetailsTabs );
	const [ id, setId ] = useState<string>( TabIDs.PROPERTY_DETAILS ); // hideServices ? TabIDs.PROPERTY_PHOTOS : TabIDs.PROPERTY_PHOTOS
	const [ count, setCount ] = useState<string>( "" );

	useEffect( () => {
		if ( hideServices ) {
			setTabs( PropertyDetailsTabs.filter( t => t.id !== TabIDs.PROPERTY_SERVICES ) );
		}
	}, [] );

	const onTabChange = ( e: React.MouseEvent ) => {
		e.preventDefault();
		const id = ( e.target as HTMLAnchorElement ).id;
		setId( id );
	};

	const onUpdateCount = ( count: number ) => {
		setCount( "" + count );
	};

	const onViewAllPhotos = () => {
		navigate( `/mydld/property/${ data.propertyTypeId }/${ data.propertyId }/photos`, undefined, {
			property: data
		} );
	};

	const onViewAllDocs = () => {
		navigate( `/mydld/property/${ data.propertyTypeId }/${ data.propertyId }/documents`, undefined, {
			property: data
		} );
	};

	return <div className="tabs mydld-property-detail-tab">
		<nav className="transformer-tabs">
			<ul>
				{ tabs.map( ( tab: ITab<any> ) => {
					let name = LocaleUtil.getLocalValue( tab.name );
					if ( tab.id === TabIDs.PROPERTY_PHOTOS && !StringUtil.isEmptyStringOrNull( count ) ) {
						name = `${ name } (${ count })`;
					}
					const tabView = <li key={ tab.id } className="nav-item">
						<a
							href="#" id={ tab.id }
							className={ `nav-link ${ tab.id === id ? "active" : "" }` }
							onClick={ onTabChange }>{ name }</a>
					</li>;
					if ( tab.id === TabIDs.PROPERTY_DOCUMENTS )
						return <Gated key={ tab.id } featureId={ "propertyDocs" }>{ tabView }</Gated>;
					return tabView;
				} ) }
			</ul>
		</nav>
		<div className={ `pt-0 ${ id === TabIDs.PROPERTY_SERVICES && "active" }` }>
			<PropertyServices services={ services }/>
		</div>
		<div className={ `pt-0 ${ id === TabIDs.PROPERTY_PHOTOS && "active" }` }>
			<PropertyPhotos
				property={ data } onViewAll={ onViewAllPhotos }
				onUpdateCount={ onUpdateCount }/>
		</div>
		<div className={ `pt-0 ${ id === TabIDs.PROPERTY_DOCUMENTS && "active" }` }>
			<PropertyDocuments propertyId={ data.propertyId } onViewAll={ onViewAllDocs }/>
		</div>
		<div className={ `pt-0 ${ id === TabIDs.MANAGEMENT_COMPANY && "active" }` }>
			<ManagementCompany tabuPropertyId={ data.tabuPropertyId }/>
		</div>
		<div className={ `pt-0 ${ id === TabIDs.PROPERTY_DETAILS && "active" }` }>
			<Details data={ data } unit={ unit! } onBCSReValuate={ onBCSReValuate } />
			{/*<ManagementCompany tabuPropertyId={ data.tabuPropertyId }/>*/}
			{/*onBCSReValuate={ this.onBCSReEvaluate }*/}
		</div>
	</div>;
}
